import axios from 'axios';

export default {
    name: 'assets-by-type',
    data() {
        return {
            auth: this.$parent.auth,
            type: this.$parent.selectedType,
            selectedTab: 'location',
            tabs: [
                { name: 'location', text: this.$t('HC_BY_LOCATION') },
                { name: 'parts', text: this.$t('HC_PARTS_LIST') }
                // { name: 'pm', text: this.$t('HC_PM_HISTORY') },
                // { name: 'workorder', text: this.$t('HC_WORK_ORDER_HISTORY') }
            ],
            assets: {},
            typesHeaders: [
                { name: 'area.name', label: this.$t('HC_LOCATION') },
                { name: 'section.name', label: this.$t('HC_SECTION') },
                { name: 'serialNumber', label: this.$t('HC_SERIAL') },
                { name: 'other', label: this.$t('HC_OTHER') },
                { name: 'warranty', label: this.$t('HC_WARRANTY') },
                { name: 'startService', label: this.$t('HC_INSTALLATION') },
                { name: 'condition', label: this.$t('HC_CONDITION') }
            ],
            partsHeaders: [
                { name: 'name', label: this.$t('HC_NAME'), width: '580' },
                {
                    name: 'itemNum',
                    label: this.$t('HC_PART_NUMBER'),
                    width: '200'
                }
            ],
            parts: {},
            searchQuery: '',
            propertyName: this.$parent.propertyName,
            currentPage: 0,
            pageSize: 20,
            minPageSize: 20,
            locationActions: [{ name: 'View' }],
            partsActions: [{ name: 'Edit' }],
            historyStack: [
                { name: 'Assets', view: 'assets' },
                { name: this.$parent.selectedCategory.name, view: 'groups' },
                { name: this.$parent.selectedType.name, url: '#' }
            ]
        };
    },
    created() {
        this.getSelectedAssetsByType(this.type.id);
    },
    methods: {
        getSelectedAssetsByType(typeId) {
            axios
                .get(
                    this.auth.v4.url +
                        `/item-types/${typeId}/items?expand=type,area,section`,
                    {
                        headers: {
                            'x-api-key': this.auth.v4.token
                        }
                    }
                )
                .then(result => {
                    let results = result.data.data;
                    this.assets = results;
                })
                .catch(() => this.$parent.showAlert());
        },
        getPartsByType() {
            axios
                .get(
                    this.auth.v4.url + `/item-types/${this.type.id}/item-parts`,
                    {
                        headers: {
                            'x-api-key': this.auth.v4.token
                        }
                    }
                )
                .then(result => {
                    let results = result.data.data;
                    this.parts = results;
                })
                .catch(() => this.$parent.showAlert());
        },
        selectTab(tab) {
            this.selectedTab = tab;
            switch (tab) {
                case 'parts':
                    this.getPartsByType();
                    break;
                case 'pm':
                    // function for pms info
                    break;
                case 'wororder':
                    // function for workorder info
                    break;
                default:
                    break;
            }
        },
        handleActionClick(item, action) {
            //Leaving this here for the ticket were actions need to work.
            // item is the object represnetation of the clicked row
            // action is provided if there are more than 1 action in the column
            console.log(item, action);
        }
    }
};
